import './Popper.scss';

import React, { useEffect, useRef, useState } from 'react';
import { usePopper } from 'react-popper';

const calculateWidth = (independentSize: $TSFixMe, childContainer: $TSFixMe) => {
  if (independentSize) {
    return false;
  }

  return childContainer ? childContainer.offsetWidth : 0;
};

const PopperContainer = ({
  children,
  className,
  show,
  trigger,
  hoverable,
  placement,
  independentSize,
  offsetX,
  offsetY,
  hideArrow,
  style,
  id,
}: $TSFixMe) => {
  const [open, setOpen] = useState(false);
  const [hasPopper, setHasPopper] = useState(false);
  const referenceElement = useRef(null);
  const childContainer = referenceElement && referenceElement.current ? referenceElement.current : null;
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);

  const { styles, attributes } = usePopper(childContainer, popperElement, {
    strategy: 'fixed',
    placement: placement || 'bottom-start',
    modifiers: [
      { name: 'arrow', options: { element: arrowElement } },
      {
        name: 'preventOverflow',
        options: {
          altAxis: true,
          padding: 20,
        },
      },
      {
        name: 'offset',
        options: {
          offset: [offsetX || 0, offsetY || 0],
        },
      },
    ],
  });

  useEffect(() => {
    const showPopper = React.Children.map(children, (child) => child && child.props.popper);
    setHasPopper(showPopper);

    window.addEventListener('scroll', handleScroll, true);

    const parentDOMChanges = new MutationObserver((records) => {
      if (records.length === 1) {
        setOpen(false);
      }
    });

    if (referenceElement.current) {
      parentDOMChanges.observe(referenceElement.current, {
        attributes: true,
      });
    }

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      parentDOMChanges.disconnect();
      setOpen(false);
    };
  }, []);

  const handleScroll = (e: $TSFixMe) => {
    setOpen(false);
  };

  const closePopper = (e: $TSFixMe) => {
    const contains = e.relatedTarget && e.relatedTarget.classList && e.relatedTarget.classList.contains('tooltip-component');

    if (hoverable && e.relatedTarget && !contains) {
      setOpen(false);
    } else if (!hoverable) {
      setOpen(false);
    }
  };

  return (
    <>
      {React.Children.map(children, (child) => (child && !child.props.reference && !child.props.popper ? React.cloneElement(child) : null))}
      {React.Children.map(children, (child) =>
        child && child.props.reference
          ? React.cloneElement(child, {
              ref: referenceElement,
              ...attributes.popper,
              onMouseOver: (e) => {
                if (child.props.onMouseOver) {
                  child.props.onMouseOver(e);
                }

                if (trigger && trigger === 'hover') {
                  setOpen(true);
                }
              },
              onMouseOut: (e) => {
                if (child.props.onMouseOut) {
                  child.props.onMouseOut(e);
                }

                if (trigger && trigger === 'hover') {
                  closePopper(e);
                }
              },
              onClick: (e) => {
                if (child.props.onClick) {
                  child.props.onClick(e);
                }

                if (trigger && trigger === 'click') {
                  setOpen(!open);
                }
              },
              onBlur: (e) => {
                if (child.props.onBlur) {
                  child.props.onBlur(e);
                }

                if (trigger && trigger === 'click') {
                  setOpen(false);
                }
              },
            })
          : null,
      )}

      {/* @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
      {(open || show) && hasPopper[0] && (
        <div
          className={`popper-popper ${className}`}
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'Dispatch<SetStateAction<null>>' is not assig... Remove this comment to see the full error message
          ref={setPopperElement}
          style={{
            ...styles.popper,
            width: calculateWidth(independentSize, childContainer),
            zIndex: 3,
            ...style,
          }}
          data-testid={`popper-container-${id ?? ''}`}
          {...attributes.popper}
        >
          {React.Children.map(children, (child) =>
            child && child.props.popper ? (
              <>
                {React.cloneElement(child, {
                  onMouseLeave: (e) => {
                    if (child.props.onMouseLeave) {
                      child.props.onMouseLeave(e);
                    }

                    if (hoverable) {
                      closePopper(e);
                    }
                  },
                })}

                {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'Dispatch<SetStateAction<null>>' is not assig... Remove this comment to see the full error message */}
                {child.props.children && !hideArrow && <div className="popper-arrow" ref={setArrowElement} style={styles.arrow} />}
              </>
            ) : null,
          )}
        </div>
      )}
    </>
  );
};

export default PopperContainer;
